/**
 * Operator-facing error strings for the clickFind (DinoFast) locate path.
 *
 * These are shown to robot operators in routine-failure UI and the teach
 * modal. They MUST NOT contain internal implementation detail (encoder model
 * names like "dinov3-vitb16", the "DinoFast" prefix, or raw backend error
 * strings). Raw detail belongs in logs only — see `runLocate.ts`.
 */
export const CLICKFIND_ERROR_MESSAGES = {
  /** Saved references were captured with a different encoder (e.g. CPU↔GPU). */
  ENCODER_MISMATCH:
    'This Find step was set up with a different vision model and needs to be re-taught. Open the step to re-teach it.',
  /** A saved step reached runtime with no positive references to match. */
  NO_REFERENCES:
    'This Find step has no references. Open the step to re-teach it.',
  /** Encoder RPC failed, returned no data, or returned no heatmap. */
  ENCODER_FAILED:
    "The vision model couldn't process the camera image. Check the logs and try again.",
  /** Teach-modal toast after auto-clearing references on an encoder switch. */
  REFERENCES_CLEARED:
    'References were captured with a different vision model and have been cleared. Click the target to re-teach.',
} as const;
